export default "__VITE_ASSET__B31j7urX__"